import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/services.css';

const PeopleIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <circle cx="9" cy="8" r="3" />
    <path d="M3 20c0-3.5 2.7-6 6-6s6 2.5 6 6" />
    <circle cx="17" cy="9" r="2.5" />
    <path d="M15 20c0-2.5 1.8-4.5 4-4.5" />
    <circle cx="19.5" cy="7" r="2" />
  </svg>
);

const ChatIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M7 9h10M7 13h6" />
    <path d="M5 5h11a3 3 0 013 3v6a3 3 0 01-3 3H10l-4 3v-3H5a3 3 0 01-3-3V8a3 3 0 013-3z" />
    <path d="M16 6h3a2 2 0 012 2v5a2 2 0 01-2 2h-2" />
  </svg>
);

const LaptopIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="3" y="5" width="18" height="11" rx="1.5" />
    <path d="M2 18h20" />
    <circle cx="15" cy="10" r="2" />
  </svg>
);

const MonitorIcon = () => (
  <svg className="services-catalog-tag-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="4" width="18" height="12" rx="1.5" />
    <path d="M8 20h8" />
  </svg>
);

const ClockIcon = () => (
  <svg className="services-catalog-tag-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="8" />
    <path d="M12 8v4l3 2" />
  </svg>
);

const CartIcon = () => (
  <svg className="services-catalog-buy-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="9" cy="20" r="1" />
    <circle cx="17" cy="20" r="1" />
    <path d="M1 1h4l2.5 13h11l2-8H6" />
  </svg>
);

const serviceCategories = [
  {
    id: 'terapias',
    label: 'Terapias',
    theme: 'peach',
    Icon: PeopleIcon,
    to: '/services/terapias',
  },
  {
    id: 'citas',
    label: 'Citas en Directo',
    theme: 'sky',
    Icon: ChatIcon,
    to: '/services/citas-directas',
  },
  {
    id: 'cursos',
    label: 'Cursos y Talleres',
    theme: 'blue',
    Icon: LaptopIcon,
    multiline: true,
  },
];

const serviceCatalog = [
  {
    id: 'fonoaudiologia',
    title: 'Fonoaudiología',
    image: 'service-fonoaudiologia.png',
    imageAlt: 'Terapia de fonoaudiología',
    description:
      'Espacio terapéutico para rehabilitar la comunicación, el lenguaje y la deglución, optimizando la funcionalidad y la calidad de vida de los jóvenes en todos sus entornos.',
  },
  {
    id: 'integracion-sensorial',
    title: 'Integración Sensorial',
    image: 'service-integracion-sensorial.png',
    imageAlt: 'Terapia de integración sensorial',
    description:
      'Intervención terapéutica para procesar e integrar estímulos sensoriales, mejorando la participación y el desempeño ocupacional en las actividades cotidianas de la persona.',
  },
  {
    id: 'terapia-ocupacional',
    title: 'Terapia Ocupacional',
    image: 'service-terapia-ocupacional.png',
    imageAlt: 'Terapia ocupacional',
    description:
      'Disciplina sanitaria que promueve la salud y el bienestar a través de la ocupación significativa, facilitando la autonomía y la participación activa en la vida diaria.',
  },
  {
    id: 'psicologia',
    title: 'Psicología',
    image: 'service-psicologia.png',
    imageAlt: 'Psicología',
    description:
      'Proceso de acompañamiento profesional para comprender y gestionar las emociones, pensamientos y conductas, fomentando el desarrollo personal y el equilibrio mental.',
  },
  {
    id: 'modificacion-conducta',
    title: 'Modificación de Conducta',
    image: 'service-modificacion-conducta.png',
    imageAlt: 'Modificación de conducta',
    description:
      'Enfoque terapéutico centrado en la modificación de conductas observables, mediante técnicas de aprendizaje para mejorar la adaptación y el funcionamiento del individuo.',
  },
  {
    id: 'estimulacion-temprana',
    title: 'Estimulación Temprana',
    image: 'service-estimulacion-temprana.png',
    imageAlt: 'Estimulación temprana',
    description:
      'Servicio sistemático de intervenciones diseñado para favorecer y acelerar el desarrollo integral del niño en la etapa crucial de los primeros años de vida.',
  },
  {
    id: 'terapia-familiar',
    title: 'Terapia Familiar',
    image: 'service-terapia-familiar.png',
    imageAlt: 'Terapia familiar',
    description:
      'Proceso de apoyo y guía profesional a la familia, fortaleciendo sus capacidades para afrontar desafíos y promover un desarrollo saludable de todos sus miembros.',
    durationTheme: 'dark',
  },
];

const ServicesPage = () => {
  return (
    <div className="services-root">
      <section className="services-section services-section-intro">
        <div className="services-hero-card">
          <h1 className="services-hero-title">Terapias, Talleres y Cursos</h1>
          <p className="services-hero-text">
            Nuestro programa ofrece una gama especializada de terapias, talleres y cursos diseñados
            específicamente. Cada actividad está cuidadosamente planificada para potenciar sus capacidades
            únicas, fomentar su desarrollo integral y fortalecer sus habilidades de comunicación, regulación
            emocional e interacción social. Trabajamos en un entorno de apoyo inclusivo que valora la
            diversidad neuronal, utilizando metodologías adaptadas que se ajustan a las necesidades
            individuales, en colaboración estrecha con las familias para garantizar un apoyo coherente y
            significativo en su día a día.
          </p>
        </div>
      </section>

      <section className="services-section services-section-categories">
        <div className="services-categories-inner">
          {serviceCategories.map((category) => {
            const content = (
              <>
                <div className={`services-category-icon services-category-icon--${category.theme}`}>
                  <category.Icon />
                </div>
                <p className={`services-category-label${category.multiline ? ' services-category-label--multiline' : ''}`}>
                  {category.multiline ? (
                    <>
                      Cursos y
                      <br />
                      Talleres
                    </>
                  ) : (
                    category.label
                  )}
                </p>
              </>
            );

            if (category.to) {
              return (
                <Link
                  key={category.id}
                  to={category.to}
                  className="services-category-card services-category-card--link"
                >
                  {content}
                </Link>
              );
            }

            return (
              <article key={category.id} className="services-category-card">
                {content}
              </article>
            );
          })}
        </div>
      </section>

      <section className="services-section services-section-catalog">
        <div className="services-catalog-inner">
          {serviceCatalog.map((service) => (
            <article key={service.id} className="services-catalog-card">
              <div className="services-catalog-visual">
                <img
                  src={`${process.env.PUBLIC_URL}/images/${service.image}`}
                  alt={service.imageAlt}
                  className="services-catalog-photo"
                />
              </div>

              <div className="services-catalog-body">
                <h2 className="services-catalog-title">{service.title}</h2>

                <div className="services-catalog-tags">
                  <span className="services-catalog-tag services-catalog-tag--training">CAPACITACIÓN</span>
                  <span className="services-catalog-tag services-catalog-tag--mode">
                    <MonitorIcon />
                    ONLINE O PRESENCIAL
                  </span>
                  <span
                    className={`services-catalog-tag services-catalog-tag--duration${
                      service.durationTheme === 'dark' ? ' services-catalog-tag--duration-dark' : ''
                    }`}
                  >
                    <ClockIcon />
                    8 Horas
                  </span>
                </div>

                <p className="services-catalog-description">{service.description}</p>
              </div>

              <button type="button" className="services-catalog-buy">
                <CartIcon />
                Comprar 0,00 US$
              </button>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
